import React, { Component } from 'react';
import Chart from 'chart.js';
import Scriba from 'react-scriba';
import { Redirect } from 'react-router-dom';
import { ChartModele } from './ChartModele';

import { Immocom } from '../../specifique/immocom';
import { DataAlarme } from '../../data/DataAlarme';

var objetState = {
    chartEnCours: null,
    chargementEnCours: false,
    redirect: false,
    afficheMessagePasDeDonnees: false
};

export class ChartDernierSuiviCommercial extends Component {

    _creationContent = () => {
        return <ChartModele
            titre="Rendez-vous à venir"
            idChart="GraphiqueDernierSuiviCommercial"
            chargementEnCours={this.state.chargementEnCours}
            afficheMessagePasDeDonnees={this.state.afficheMessagePasDeDonnees}
        />;
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _chargementDonnees() {

        this.setState({
            chargementEnCours: true,
            afficheMessagePasDeDonnees: false
        });

        let chargementNombreSouhaitsParDernierSuiviCommercial = DataAlarme._chargementNombreSouhaitsParDernierSuiviCommercial();

        chargementNombreSouhaitsParDernierSuiviCommercial
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    //Chargement des données
                    let Legendes = [];
                    let Valeurs = [];
                    let Couleurs = [];
                    let CouleursSurvol = [];
                    let ListeDureeMin = [];
                    let ListeDureeMax = [];

                    if (objetData.length > 0) {
                        objetData.map(res => {
                            Legendes.push(res.libelle);
                            Valeurs.push(res.total);
                            Couleurs.push(res.couleurPrincipale);
                            CouleursSurvol.push(res.couleurSurvol);
                            ListeDureeMin.push(res.dureeMin);
                            ListeDureeMax.push(res.dureeMax);
                        });

                        //On déclare this dans une variable afin de ne pas le confondre avec le this correspondant à l'objet chart
                        let _this = this;

                        var GraphiqueDernierSuiviCommercial = new Chart('GraphiqueDernierSuiviCommercial', {
                            type: 'bar',
                            data: {
                                labels: Legendes,
                                datasets: [{
                                    label: 'Nombre de souhaits',
                                    data: Valeurs,
                                    backgroundColor: Couleurs,
                                    hoverBackgroundColor: CouleursSurvol,
                                    conditionDureeMin: ListeDureeMin,
                                    conditionDureeMax: ListeDureeMax
                                }]
                            },
                            options: {
                                "scales": {
                                    "yAxes": [{
                                        "ticks": {
                                            "beginAtZero": true,
                                            "min": 0,
                                            "stepSize": 1
                                        }
                                    }]
                                },
                                'onClick': function (evt, item) {

                                    if (item.length > 0) {

                                        //Récupération du statut sélectionné
                                        let ElementTrav = item[0];
                                        let IndexTrav = ElementTrav._index;
                                        let RequeteConditionDureeMin = ElementTrav._chart.data.datasets[0].conditionDureeMin[IndexTrav];
                                        let RequeteConditionDureeMax = ElementTrav._chart.data.datasets[0].conditionDureeMax[IndexTrav];

                                        if (RequeteConditionDureeMin !== null) {
                                            localStorage.setItem('filtreMinJourDernierSuiviCommercialOuRdv', RequeteConditionDureeMin);
                                        }

                                        if (RequeteConditionDureeMax !== null) {
                                            localStorage.setItem('filtreMaxJourDernierSuiviCommercialOuRdv', RequeteConditionDureeMax);
                                        }

                                        _this.setState({
                                            redirect: true
                                        });
                                    }
                                }
                            }
                        });

                        this.setState({
                            chartEnCours: GraphiqueDernierSuiviCommercial,
                            chargementEnCours: false
                        })
                    }
                    else {
                        this.setState({
                            afficheMessagePasDeDonnees: true,
                            chargementEnCours: false
                        });
                    }
                }
                else {
                    let stateTemp = {};
                    stateTemp.chartEnCours = null;
                    stateTemp.chargementEnCours = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    _onRechargement() {

        //On détruit le graph avant de le recharger
        if (this.state.chartEnCours !== null) {
            this.state.chartEnCours.destroy();
        }

        this._chargementDonnees();
    }

    render = () => {
        if (this.state.redirect) {
            return <Redirect to='/Prospection/ListeSouhaits' />;
        } else {
            return this._creationContent();
        }
    }
}